import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { booleanQueryParam } from "../common/query-params.js";
export const categoryInfo = z.object({
    id: z.string().uuid(),
    parentId: z.string().uuid().nullable(),
    code: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createCategoryRequest = z.object({
    parentId: z.string().uuid().nullish(),
    code: z.string().min(1).max(100),
    name: z.string().min(1).max(255),
    isActive: z.boolean().default(true),
    metadata: z.record(z.unknown()).default({}),
});
export const updateCategoryRequest = createCategoryRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
// parentId in query: omit = no filter; "null" string = roots only; uuid = children of
// sort: "name" = alphabetical (A→Z); omit = default (most recently updated first).
// Alphabetical ordering matters for server-side paged pickers/lists so pages
// don't reshuffle as rows are edited.
export const listCategoriesQuery = paginationQuerySchema.extend({
    parentId: z.string().optional(),
    isActive: booleanQueryParam.optional(),
    search: z.string().max(255).optional(),
    sort: z.enum(["name", "recent"]).optional(),
});
export const categoriesListResponse = pagedResponse(categoryInfo);
//# sourceMappingURL=categories.schemas.js.map